$(document).ready(function () {

    function updateMainMargin() {
        const $header = $(".header-section");
        const $main = $("#MainContent");

        if ($header.length && $main.length) {
            const headerHeight = $header.outerHeight(true);  
            $main.css("margin-top", headerHeight + "px"); 
        }
    }

    
    $(window).on("load", updateMainMargin);

     
    let resizeTimer;
    $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMainMargin, 300);
    });

     
    const headerEl = document.querySelector(".header-section");
    if (headerEl) {
        const observer = new MutationObserver(() => {
            updateMainMargin();
        });
        observer.observe(headerEl, { attributes: true, childList: true, subtree: true });
    }

     
    setTimeout(updateMainMargin, 500);

    setTimeout(function(){
        $(".countdown-timer-block").each(function () {
            if ($.trim($(this).html()) === "") {
                $(this).remove(); 
            }
        });
    }, 500) 
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('button[class^="countdown_annoucement_bar_close_button_"]');
  if (btn) {
    const block = document.querySelector('.countdown-timer-block');
    if (block) {
      block.remove();
    } else {
    }
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const countdownWrappers = document.querySelectorAll('.countdown-wrapper');

  countdownWrappers.forEach(wrapper => {
    const endDateAttr = wrapper.getAttribute('data-end-date');
    if (!endDateAttr) return;

    const endDate = new Date(endDateAttr).getTime();
    const headerEl = wrapper.querySelector('.countdown-header');
    const timerEl = wrapper.querySelector('#countdown-timer');

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance <= 0) {
        if (headerEl) headerEl.innerHTML = "OFFER ENDED";
        if (timerEl) timerEl.innerHTML = "";
        clearInterval(timer);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (headerEl) headerEl.innerHTML = "ENDS IN ";
      if(timerEl.classList.contains('no-colon')){
        timerEl.innerHTML = `
          <span>${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s</span>`;
      }else if (timerEl) {
        timerEl.innerHTML = `
          <span>${String(days).padStart(2, '0')}d</span> :
          <span>${String(hours).padStart(2, '0')}h</span> :
          <span>${String(minutes).padStart(2, '0')}m</span> :
          <span>${String(seconds).padStart(2, '0')}s</span>
        `;
      }
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
  });
});


